import host from '../../../config/host';
import { ajax, http } from '../../../libs/util';

const http_host = host.secret;

const util = {
  apiUrl(path) {
    return `${http_host}/api/${path}`;
  },
  getWageItems() {
    return http.get(this.apiUrl('wage/items'));
  },
  // getSocialSecurity() {
  //   return http.get(this.apiUrl('social_insurance/list')); 
  // },
  getSmsCode() {
    return http.get(this.apiUrl('wage/verify_code'));
  },
  getRecords(params) {
    return http.get(this.apiUrl('wage/records'), params);
  },
  getSocialRecords(params) {
    return http.get(this.apiUrl('social_insurance/list'), params);
  },
  updateRecord(record) {
    return http.post(this.apiUrl('wage/update_record'), record);
  },
  delRecord(record) {
    return http.post(this.apiUrl('wage/delete'), {id: record.id});
  },
  delSocialRecord(record) {
    return http.post(this.apiUrl('social_insurance/delete'), {id: record.id});
  },
  importSocialFile(formData, onProgress = () => {}) {
    return new Promise((resolve, reject) => {
      ajax({
        url: this.apiUrl('social_insurance/import'),
        method: 'post',
        data: formData,
        timeout: 120000,
        onUploadProgress: (e) => {
          const percent = e.loaded / e.total * 100;
          onProgress && onProgress(percent < 0.1 ? 0.1 : percent);
        },
      }).then(response => {
        return response.data;
      }).then(({code, data, msg}) => {
        if (code === 1) {
          resolve(data.records);
        } else {
          reject({message:msg});
        }
      }).catch((e) => {
        reject(e);
      })
    })
  },
  importFile(formData, onProgress = () => {}) {
    return new Promise((resolve, reject) => {
      ajax({
        url: this.apiUrl('wage/import'),
        method: 'post',
        data: formData,
        timeout: 120000,
        onUploadProgress: (e) => {
          const percent = e.loaded / e.total * 100;
          onProgress && onProgress(percent < 0.1 ? 0.1 : percent);
        },
      }).then(response => {
        return response.data;
      }).then(({code, data, msg}) => {
        if (code === 1) {
          resolve(data.records);
        } else {
          reject({message:msg});
        }
      }).catch((e) => {
        reject(e);
      })
    })
  },
  genBill({ month, payment_type, codes, bills, company_ids, payment_batch }, is_formal) {
    if (is_formal) {
      return http.post(this.apiUrl('wage/gen_bill'), {
        month,
        payment_type, 
        codes,
        company_ids,
        payment_batch
      });
    }
    return http.post('expense_group/gen_bills', {
      month,
      payment_type, 
      bills,
      payment_batch
    });
  }
};

export default util;
